module.exports = __webpack_public_path__ + "static/media/5.jpg.487ccf26.webp";